import React from "react";
import PropTypes from "prop-types";
import Cookies from "universal-cookie";

class WarehouseSidebar extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      openTabs: [],
    }

    this.openOnMouseOver = this.openOnMouseOver.bind(this);
    this.toggleTab = this.toggleTab.bind(this);
  }

  openOnMouseOver() {
    const { sidebarOpen, toggleSidebar } = this.props;
    if(!sidebarOpen) {
      $("#items").collapse();
      this.setState({openTabs: []});
      toggleSidebar(true);
    }
  }

  toggleTab(name) {
    const { openTabs } = this.state;
    const index = openTabs.indexOf(name);
    this.setState({
      openTabs: index != -1 ? openTabs.filter(tab => tab != name) : openTabs.concat([name])
    })
  }

  isTabOpen(name) {
    const { openTabs } = this.state;
    return openTabs.includes(name);
  }


  getTabClass(name) {
    return this.isTabOpen(name) ? "collapse in" : "collapse"
  }



  render() {

    return (
      <div className="warehouse-sidebar" onMouseEnter={this.openOnMouseOver}>
        <div className="warehouse-sidebar-content">
          <ul className="nav">

            <hr />
            <li className="nav-item">
              <a className="nav-link" href="/">
                <i className="fas fa-angle-left"></i>
                <span className="menu-title">Public Catalog</span>
              </a>
            </li>
            <li className="nav-item">
              <a className="nav-link" rel="nofollow" href="/users/sign_out">
                <i className="fas fa-sign-out-alt"></i>
                <span className="menu-title">
                  Sign Out
                </span>
              </a>
            </li>
          </ul>
        </div>
      </div>
    );
  }
}

WarehouseSidebar.propTypes = {
  sidebarOpen: PropTypes.bool.isRequired,
};

export default WarehouseSidebar;
